var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "lds-spinner",
    width: "70px",
    height: "70px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    style: {
      background: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.99s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(3.6 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.98s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(7.2 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.97s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(10.8 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.96s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(14.4 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.95s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(18 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.94s",
    repeatCount: "indefinite"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(21.6 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.93s",
    repeatCount: "indefinite"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(25.2 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.92s",
    repeatCount: "indefinite"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(28.8 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.91s",
    repeatCount: "indefinite"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(32.4 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.9s",
    repeatCount: "indefinite"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(36 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.89s",
    repeatCount: "indefinite"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(39.6 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.88s",
    repeatCount: "indefinite"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(43.2 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.87s",
    repeatCount: "indefinite"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(46.8 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.86s",
    repeatCount: "indefinite"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(50.4 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.85s",
    repeatCount: "indefinite"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(54 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.84s",
    repeatCount: "indefinite"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(57.6 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.83s",
    repeatCount: "indefinite"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(61.2 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.82s",
    repeatCount: "indefinite"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(64.8 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.81s",
    repeatCount: "indefinite"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(68.4 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.8s",
    repeatCount: "indefinite"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.79s",
    repeatCount: "indefinite"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(75.6 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.78s",
    repeatCount: "indefinite"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(79.2 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.77s",
    repeatCount: "indefinite"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(82.8 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.76s",
    repeatCount: "indefinite"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(86.4 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.75s",
    repeatCount: "indefinite"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.74s",
    repeatCount: "indefinite"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(93.6 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.73s",
    repeatCount: "indefinite"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(97.2 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.72s",
    repeatCount: "indefinite"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(100.8 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.71s",
    repeatCount: "indefinite"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(104.4 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.7s",
    repeatCount: "indefinite"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(108 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.69s",
    repeatCount: "indefinite"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(111.6 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.68s",
    repeatCount: "indefinite"
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(115.2 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.67s",
    repeatCount: "indefinite"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(118.8 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.66s",
    repeatCount: "indefinite"
  })))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(122.4 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.65s",
    repeatCount: "indefinite"
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(126 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.64s",
    repeatCount: "indefinite"
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(129.6 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.63s",
    repeatCount: "indefinite"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(133.2 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.62s",
    repeatCount: "indefinite"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(136.8 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.61s",
    repeatCount: "indefinite"
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(140.4 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.6s",
    repeatCount: "indefinite"
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.59s",
    repeatCount: "indefinite"
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(147.6 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.58s",
    repeatCount: "indefinite"
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(151.2 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.57s",
    repeatCount: "indefinite"
  })))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(154.8 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.56s",
    repeatCount: "indefinite"
  })))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(158.4 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.55s",
    repeatCount: "indefinite"
  })))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(162 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.54s",
    repeatCount: "indefinite"
  })))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(165.6 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.53s",
    repeatCount: "indefinite"
  })))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(169.2 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.52s",
    repeatCount: "indefinite"
  })))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(172.8 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.51s",
    repeatCount: "indefinite"
  })))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(176.4 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5s",
    repeatCount: "indefinite"
  })))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.49s",
    repeatCount: "indefinite"
  })))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(183.6 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.48s",
    repeatCount: "indefinite"
  })))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(187.2 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.47s",
    repeatCount: "indefinite"
  })))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(190.8 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.46s",
    repeatCount: "indefinite"
  })))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(194.4 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.45s",
    repeatCount: "indefinite"
  })))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(198 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.44s",
    repeatCount: "indefinite"
  })))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(201.6 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.43s",
    repeatCount: "indefinite"
  })))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(205.2 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.42s",
    repeatCount: "indefinite"
  })))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(208.8 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.41s",
    repeatCount: "indefinite"
  })))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(212.4 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.4s",
    repeatCount: "indefinite"
  })))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(216 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.39s",
    repeatCount: "indefinite"
  })))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(219.6 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.38s",
    repeatCount: "indefinite"
  })))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(223.2 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.37s",
    repeatCount: "indefinite"
  })))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(226.8 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.36s",
    repeatCount: "indefinite"
  })))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(230.4 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.35s",
    repeatCount: "indefinite"
  })))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(234 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.34s",
    repeatCount: "indefinite"
  })))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(237.6 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.33s",
    repeatCount: "indefinite"
  })))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(241.2 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.32s",
    repeatCount: "indefinite"
  })))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(244.8 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.31s",
    repeatCount: "indefinite"
  })))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(248.4 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.3s",
    repeatCount: "indefinite"
  })))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(252 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.29s",
    repeatCount: "indefinite"
  })))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(255.6 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.28s",
    repeatCount: "indefinite"
  })))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(259.2 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.27s",
    repeatCount: "indefinite"
  })))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(262.8 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.26s",
    repeatCount: "indefinite"
  })))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(266.4 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.25s",
    repeatCount: "indefinite"
  })))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(270 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.24s",
    repeatCount: "indefinite"
  })))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(273.6 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.23s",
    repeatCount: "indefinite"
  })))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(277.2 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.22s",
    repeatCount: "indefinite"
  })))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280.8 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.21s",
    repeatCount: "indefinite"
  })))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(284.4 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.2s",
    repeatCount: "indefinite"
  })))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(288 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.19s",
    repeatCount: "indefinite"
  })))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(291.6 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.18s",
    repeatCount: "indefinite"
  })))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(295.2 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.17s",
    repeatCount: "indefinite"
  })))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(298.8 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.16s",
    repeatCount: "indefinite"
  })))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(302.4 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.15s",
    repeatCount: "indefinite"
  })))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(306 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.14s",
    repeatCount: "indefinite"
  })))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(309.6 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.13s",
    repeatCount: "indefinite"
  })))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(313.2 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.12s",
    repeatCount: "indefinite"
  })))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(316.8 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.11s",
    repeatCount: "indefinite"
  })))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320.4 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.1s",
    repeatCount: "indefinite"
  })))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(324 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.09s",
    repeatCount: "indefinite"
  })))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(327.6 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.08s",
    repeatCount: "indefinite"
  })))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(331.2 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.07s",
    repeatCount: "indefinite"
  })))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(334.8 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.06s",
    repeatCount: "indefinite"
  })))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(338.4 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.05s",
    repeatCount: "indefinite"
  })))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(342 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.04s",
    repeatCount: "indefinite"
  })))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(345.6 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.03s",
    repeatCount: "indefinite"
  })))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(349.2 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.02s",
    repeatCount: "indefinite"
  })))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(352.8 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.01s",
    repeatCount: "indefinite"
  })))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(356.4 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29,
    rx: 0,
    ry: 0,
    width: 6,
    height: 2,
    fill: "#4d4cb2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "0s",
    repeatCount: "indefinite"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.94ef73fface306ba11067167977eb2de.svg";
export { ForwardRef as ReactComponent };